<template>
	<div class="hero-block">

		<div class="hero-block__controls">
			<div class="hero-block__control hero-block__control-left">
				<button v-on:click="previousSlide()"
						v-if="currentIndex !== 0"
						v-html="require('!raw-loader!./hero-control-arrow.svg').default"
				>
				</button>
			</div>
			<div class="hero-block__control hero-block__control-right">
				<button v-on:click="nextSlide()"
						v-if="currentIndex !== context.items.length - 1"
						v-html="require('!raw-loader!./hero-control-arrow.svg').default"
				>
				</button>
			</div>
		</div>

		<div class="hero-block__items" ref="container" v-on:scroll="handleScroll">

			<div class="hero-block__item" v-for="item in context.items" v-bind:style="{'background-color': item.background_color}">

				<div class="hero-block__item-image">
					<ResponsiveImage v-bind:image="item.image"></ResponsiveImage>
				</div>

				<div class="hero-block__item-text">
					<div class="hero-block__item-top-text" v-if="item.top_text" v-html="item.top_text"></div>
					<a v-bind:href="item.link" class="hero-block__item-text-title">
						<h1>
							{{ item.title }}
						</h1>
					</a>
					<div class="hero-block__item-text-subtitle">
						{{ item.subtitle }}
					</div>
					<div class="hero-block__item-text-text">
						{{ item.text }}
					</div>
					<a class="lillan-button"
					   v-if="item.button"
					   v-bind:href="item.button.url"
					>
						<span v-if="item.button_icon" v-html="require('!raw-loader!../../images/icon-ticket.svg').default"></span><span>{{ item.button.title }}</span>
					</a>
				</div>

			</div>
		</div>
	</div>
</template>

<script>
	import ResponsiveImage from "../../elements/ResponsiveImage.vue";

	export default {
		props: ["context"],
		components: {
			ResponsiveImage,
		},
		data: function() {
			return {
				currentIndex: 0,
			}
		},
		methods: {
			handleScroll: function(event) {
				this.currentIndex = Math.round(this.$refs.container.scrollLeft / this.$refs.container.offsetWidth)
			},
			nextSlide: function () {
				this.$refs.container.scrollLeft = this.$refs.container.scrollLeft + this.$refs.container.offsetWidth;
			},
			previousSlide: function () {
				this.$refs.container.scrollLeft = this.$refs.container.scrollLeft - this.$refs.container.offsetWidth;
			},
		}
	}
</script>
